import template from './floor.jade';

export default angular
    .module('cian.addForm.floor', [])
    .directive('cianAfAboutObjectFloor', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            this.minFloorNumber = 0;
        },
        controllerAs: 'floor',
        template,
    }))
    .name;
